import React, { useEffect, useState } from 'react'
import { t } from '@lingui/macro'
import ResettableInput from 'front-end/src/components/common/form/input/ResettableInput'
import { useDebouncedState } from 'front-end/src/app/hooks/useDebouncedState'

const SEARCH_SUBMIT_DELAY = 200

export const ManageGroupsFilter = ({ setFilteredSearch, setPage }) => {
  const [searchValue, setSearchValue] = useState<string>('')
  const debouncedSearchTerm = useDebouncedState(
    searchValue,
    SEARCH_SUBMIT_DELAY
  )

  useEffect(() => {
    setFilteredSearch && setFilteredSearch(searchValue)
  }, [debouncedSearchTerm])

  return (
    <ResettableInput
      onChange={(searchValue: string) => {
        setPage(1)
        setSearchValue(searchValue)
      }}
      placeholder={t`Search`}
      title={t`Search`}
      showResetButton={!!searchValue}
      showSearchIcon={true}
      light={true}
      value={searchValue}
      onReset={() => {
        setSearchValue('')
        setFilteredSearch('')
      }}
    />
  )
}
